module.exports = __webpack_public_path__ + "static/media/nc.aafce2fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/nc.png
// module id = 1939
// module chunks = 0